import styled from 'styled-components'

import { Location } from './Location'

type Props = {
	location: Location
}

export const Shared = styled.div<Props>`
	left: ${({ location }) => {
		switch (location) {
			case Location.Top:
			case Location.Bottom:
				return '50%'
			case Location.Right:
				return 'calc(100% + 5px)'
			case Location.Left:
				return 'auto'
		}
	}};
	bottom: ${({ location }) => {
		switch (location) {
			case Location.Top:
				return 'calc(100% + 5px)'
			case Location.Bottom:
				return 'auto'
			case Location.Right:
			case Location.Left:
				return '50%'
		}
	}};
	opacity: 0;
	pointer-events: none;
	position: absolute;
	right: ${({ location }) => (location === Location.Left ? 'calc(100% + 5px)' : 'auto')};
	top: ${({ location }) => (location === Location.Bottom ? 'calc(100% + 5px)' : 'auto')};
	transition: 0.2s;
	visibility: hidden;
	z-index: 10;
`
